
import { DashboardTab } from "@/utils/dashboard/dashboard-tab";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			name: this.$ct("new-tab").toString()
		};
	},
	props: {
		value: {
			type: Object as ()=>DashboardTab,
			required: true
		},
		isNew: Boolean
	},
	computed: {
		title():TranslateResult{
			if (this.isNew) {
				return this.$ct("create-new-tab");
			}
			return this.$ct("edit-tab");
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				if (!this.value.Name) return;
				this.name = this.value.Name;
			}
		}
	},
	methods: {
		save(){
			this.value.Name = this.name;
			this.$emit("save", this.value);
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
